(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningItemAssignmentLocalizationResource", ["$resource", learningItemAssignmentLocalizationResource]);
    function learningItemAssignmentLocalizationResource($resource) {
        return $resource("/api/learningItemAssignmentLocalization/:id/:localizationId/:action", { id: "@id", localizationId: "@localizationId", action: "@action" }, {
            updateScore: {
                method: "POST",
                params: { action: "updateScore" }
            },
            uploadTemplate: {
                method: "POST",
                params: { action: "uploadTemplate" }
            },
            removeTemplate: {
                method: "POST",
                params: { action: "removeTemplate" }
            }
        });
    }
}());
